<template>
    <v-stepper-header style="background-color: #607d8b !important; color: #ffffff !important;" class="sticky">
        <v-stepper-step
            editable
            :step="1"
            @click="() => onClick_StepperHeader('1')">
            Overview
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="2"
            @click="() => onClick_StepperHeader('2')">
            Flight Duty Time
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="3"
            @click="() => onClick_StepperHeader('3')">
            Duty Time
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="4"
            @click="() => onClick_StepperHeader('4')">
            Flight Time
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="5"
            @click="() => onClick_StepperHeader('5')">
            Rest Periods
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="6"
            @click="() => onClick_StepperHeader('6')">
            Trainings & Checks
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="7"
            @click="() => onClick_StepperHeader('7')">
            Early/Late Night Duties
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            editable
            :step="8"
            @click="() => onClick_StepperHeader('8')">
            Standbys
        </v-stepper-step>
    </v-stepper-header>
</template>

<script>
    import { eventBus } from '../../../../../../../main';


    export default {
        name: 'StepperHeader',


        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // TODO: Delete rpops
            validations: Object,
            validationSelectedFlights: Object

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                activeTabNumber: 1 // rememer active tab
            };

        }, // eo data{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/StepperHeader.vue >>> created');
            eventBus.$on('reloadvisibletab', this.onClick_StepperHeader); // emit after 'Brief Load'

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/StepperHeader.vue >>> destroyed');
            eventBus.$off('reloadvisibletab', this.onClick_StepperHeader); // emit after 'Brief Load'

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Gets called on: 'TabClick' & 'Emit after Brief Load'.
            * Note: For reloading visible Tab after new Resource selected.
            * Note:
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                let me = this;


				me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/StepperHeader.vue >>> onClick_StepperHeader');
                if (!stepperNumber) { // via emit (after 'Brief Load')
                    stepperNumber = this.activeTabNumber; // reload visible tab
                }

                me.$emit('change', stepperNumber);
                this.activeTabNumber = stepperNumber;

            }, // eo function onClick_StepperHeader()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }
</style>

<style>
    .theme--light.v-stepper .v-stepper__label {
        color: rgba(255, 255, 255, 1) !important;
    }

    .sticky {
        position: sticky;
        top: 0;
        z-index: 1;
    }
    /* position:relative;z-index:10000; was before in style */
</style>